import React from "react";
import { Tooltip } from "antd";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { readableDateTime } from "../../utilities/helper";

dayjs.extend(relativeTime);

// Within this many days show "2 hours ago"; older dates show the exact date
const RECENT_DAYS = 7;

/**
 * Recent timestamps as relative time ("2 hours ago") with the exact date and
 * time on hover; older ones as the exact date and time.
 */
const TimeAgo = ({ value }) => {
  if (!value) return "--";

  const date = dayjs(value);
  if (!date.isValid()) return "--";

  const exact = readableDateTime(value, "dd/mm/yyyy hh:mm");

  if (Math.abs(dayjs().diff(date, "day", true)) >= RECENT_DAYS) {
    return exact;
  }

  return (
    <Tooltip title={exact}>
      <span className="time-ago">{date.fromNow()}</span>
    </Tooltip>
  );
};

export default TimeAgo;
